import { CircularProgress, Stack } from "@mui/material"
import { useEffect } from "react"
import { rootStore, useStores } from "stores/root-store"
import { MainComponent, ContentWrapper, AppLoadingContainer } from "components/common-styles"
import { useParams } from "react-router-dom"
import BreadcrumbHeader from "components/common/breadcrumb-header"
import { observer } from "mobx-react-lite"
import BomComponents from "components/bom/details/bom-components"
import HeaderInfo from "components/bom/details/header-info"
import BomForm from "components/bom/dialog/bom-form"

const BomDetail = () => {
  const { item } = useParams()

  const onEditClicked = () => {
    rootStore.setOpenForm(true)
  }

  const { BillOfMaterialStore } = useStores()

  useEffect(() => {
    BillOfMaterialStore.loadDetailData(item)
  }, [BillOfMaterialStore, item, BillOfMaterialStore.forceReload])

  if (BillOfMaterialStore.isLoading || !BillOfMaterialStore.bomInfo) {
    return (
      <AppLoadingContainer>
        <CircularProgress size={64} />
      </AppLoadingContainer>
    )
  }

  const handleClose = () => {
    rootStore.setOpenForm(false)
  }

  const handleSave = () => {
    handleClose()
    BillOfMaterialStore.setForceReload()
  }

  if (rootStore.openForm) return <BomForm onSave={handleSave} onClose={handleClose} />

  return (
    <>
      <BreadcrumbHeader />
      <MainComponent component="main">
        <ContentWrapper maxWidth={"xl"}>
          <Stack spacing={2}>
            <HeaderInfo onEditClicked={onEditClicked} />
            <BomComponents />
          </Stack>
        </ContentWrapper>
      </MainComponent>
    </>
  )
}

export default observer(BomDetail)
